/* eslint-disable
    func-names,
    no-shadow,
*/
const _ = require('lodash');

const deps = ['Model', 'ClientInfoVM', 'Validate'];
const factory = function (Model, ClientInfoVM, Validate) {
  let ClientInfo;
  return (ClientInfo = (function () {
    ClientInfo = class ClientInfo extends Model {
      static initClass() {
        this.prototype.$resource = 'clientinfo';
        this.prototype.$viewModelType = ClientInfoVM;

        this.prototype.catchUpEndDate = null;
        this.prototype.catchUpStartDate = new Date();
        this.prototype.clientId = '';
        this.prototype.communicationFrequency = '';
        this.prototype.communicationPreference = '';
        this.prototype.cpaApproved = false;
        this.prototype.cpaName = '';
        this.prototype.cpaTrialBalance = false;
        this.prototype.equityTransactions = '';
        this.prototype.industry = '';
        this.prototype.inventory = '';
        this.prototype.lastFiling = '';
        this.prototype.members = '';
        this.prototype.nextTargetFiling = '';
        this.prototype.payReimbursements = '';
        this.prototype.paymentSystem = '';
        this.prototype.structure = '';
        this.prototype.thirdPartyLogin = '';
        this.prototype.yearEnd = '';
        this.prototype.secondaryContactFirstName = '';
        this.prototype.secondaryContactLastName = '';
        this.prototype.secondaryContactPhone = '';
        this.prototype.secondaryContactEmail = '';
        this.prototype.taxClient = false;

        this.prototype.$validators = {
          firstName: {
            nonEmpty: Validate.required(),
          },
          lastName: {
            nonEmpty: Validate.required(),
          },
          email: {
            nonEmpty: Validate.required(),
          },
          phone: {
            nonEmpty: Validate.required(),
          },
          city: {
            nonEmpty: Validate.required(),
          },
          province: {
            nonEmpty: Validate.required(),
          },
        };

        this.prototype.$errorMessages = {
          firstName: {
            nonEmpty: 'First Name is required',
          },
          lastName: {
            nonEmpty: 'Last Name is required',
          },
          email: {
            nonEmpty: 'Email is required',
          },
          phone: {
            nonEmpty: 'Phone Number is required',
          },
          city: {
            nonEmpty: 'City is required',
          },
          province: {
            nonEmpty: 'Province is required',
          },
        };
      }

      $serialize(data) {
        const newData = angular.copy(data);

        const dateKeys = [
          'catchUpEndDate',
          'catchUpStartDate',
          'lastFiling',
          'nextTargetFiling',
          'yearEnd',
          'businessStartDate',
        ];

        // convert timestamp to date
        dateKeys.forEach(key => (newData[key] = data[key] ? new Date(data[key]) : ''));

        // turn [a, b, c] to "a,b,c"
        const stringToArray = function (string) {
          if (_.isString(string)) {
            return string.split(',').filter(val => val) || [];
          }
          return [];
        };

        newData.paymentSystem = stringToArray(newData.paymentSystem);
        newData.customLedgers = stringToArray(newData.customLedgers);

        return newData;
      }

      $deserialize(data) {
        const newData = angular.copy(data);

        // convert dates to timestamp
        Object.keys(data).forEach(key => {
          if (data[key] instanceof Date) {
            return (newData[key] = data[key].getTime());
          }
        });

        const arrayToString = function (array) {
          if (_.isArray(array)) {
            return array.join(',');
          }
          return '';
        };

        newData.paymentSystem = arrayToString(data.paymentSystem);
        newData.customLedgers = arrayToString(data.customLedgers);

        return newData;
      }
    };
    ClientInfo.initClass();
    return ClientInfo;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name, require('data/viewModel/clientinfo').name];

module.exports = angular
  .module('bench.data.model.clientinfo', moduleDeps)
  .factory('ClientInfo', factory);
